import { useChat as useBaseChat } from '@ai-sdk/react';
import { getBaseUrl } from '@docnboard/rest';

export const useChat = () => {
  const chat = useBaseChat({
    id: 'docnboard-ai',
    api: `${getBaseUrl()}/api/v2/ai/completions`,
  });

  return { ...chat };
};
